import * as React from 'react';
import PassengersToolbarWithoutForm from './components/PassengersToolbarWithoutForm/PassengersToolbarWithoutForm';
import PassengersToolbarWithForm from './components/PassengersToolbarWithForm/PassengersToolbarWithForm';
const PassengersToolbar = props => {
    const { hasForm } = props;
    if (!hasForm) {
        return React.createElement(PassengersToolbarWithoutForm, Object.assign({}, props));
    }
    return React.createElement(PassengersToolbarWithForm, Object.assign({}, props));
};
export default PassengersToolbar;
